import React from 'react';
import { inject, observer } from 'mobx-react';
import { ReactSVG } from 'react-svg';
import clsx from 'classnames';

import { handleRequest } from '@/utils';
import { addDialogue, updateDialogueInfo } from '@/utils/sessionUtils';
import { IntentSource, IntentType } from '@/types/intent';
import { SHORTCUT_TYPE } from '@/types/store/init';
import { TRACKING_TYPE, SHORTCUT_RESPONSE_TYPE, ORDER_SHORTCUT, NO_ORDER_SHORTCUT, ShortcutType } from '@/utils/constants';
import { TRACKING_OP_TYPE } from '@/utils/tracking/constants';
import handleClickIntent from '@/utils/intent/handleClickIntent';
import handleClickOrderShortcut from '@/utils/intent/handleClickOrderShortcut';
import { getChildInject, isNum } from '@/utils/instantLoaded/tools';
import { tracker } from '@/utils/tracking';
import { isLiveAgentScUIOptimisation, isShortCutNewUI, isShortCutPopupDisplay } from '@/utils/experiment/getShortCutUIUXExperiment';
import LiveAgentScIcon from '@/assets/img/live-agent-sc-icon.svg';


const clickFunc = {
  [ShortcutType.Order]: handleClickOrderShortcut,
  [ShortcutType.Intent]: handleClickIntent,
};
@tracker
@inject(getChildInject('initStore', 'modalStore', 'inputStore', 'sessionStore'))
@observer
export default class Shortcuts extends React.PureComponent {
  static defaultProps = {
    index: 0,
    shortcut: {},
    passedRef: React.createRef(),
    onClick: () => { },
    // stores
    initStore: {},
    inputStore: {},
  };

  constructor(props) {
    super(props);
    const {
      shortcut,
      index,
      initStore: { kbBotId, kbBotName },
      sessionStore: { currentDialogueId },
    } = this.props;

    this.trackingname = TRACKING_TYPE.SHORTCUT;
    this.trackingdata = {
      content: shortcut.shortcut_message,
      shortcut_content: shortcut.shortcut_message,
      shortcut_id: shortcut.shortcut_id,
      location: index,
      is_ds_predicted: shortcut.intent_type === IntentType.Prediction,
      is_to_live_agent:
        shortcut.is_live_agent ? SHORTCUT_RESPONSE_TYPE.IS_LIVE_AGENT : SHORTCUT_RESPONSE_TYPE.NOT_LIVE_AGENT,
      intent_source: shortcut.intent_source,
      kb_intent_id: shortcut.intent_source === IntentSource.KnowledgeBase ? shortcut.shortcut_id : undefined,
      bot_id: kbBotId,
      bot_name: kbBotName,
      is_order_shortcut: shortcut.shortcut_type === ShortcutType.Order ? ORDER_SHORTCUT : NO_ORDER_SHORTCUT,
      model_name: shortcut.is_live_agent ? 'Live Agent Control' : 'Intent Prediction',
      chat_dialogue_id: currentDialogueId || 0,
    };
  }

  handleShortcutClick = (shortcut) => () => {
    const { initStore, inputStore } = this.props;
    const { shortcutType } = initStore;
    const { isShortCutExpand } = inputStore;

    // 如果是有shortcut popup样式的分组，且shortcuts为展开状态，点击收起shortcuts
    if (isShortCutPopupDisplay() && isShortCutExpand) {
      this.props.onClick();
    }

    // 旧的shortcut 都是配置好的
    if (shortcutType === SHORTCUT_TYPE.ConfiguredShortcut) {
      const curPos = addDialogue({
        from: 'user',
        type: 'Msg',
        data: { content: shortcut.actual_message },
      });

      if (isNum(curPos)) {
        const params = shortcut.type === 1
          ? { ...(shortcut.query_callback || {}) }
          : {
            session_id: this.props.initStore.sessionId,
            shortcut_id: shortcut.shortcut_id,
          };
        handleRequest('getShortcutAnswer', params, { curPos }).then(res => {
          res && updateDialogueInfo({
            dialogueId: res.dialogue_id,
            dialogueType: res.dialogue_type,
          }, curPos);
          // 点击埋点
          this.trackingHandler({ next_chat_dialogue_id: res?.dialogue_id });
        });
      }
    } else {
      // 新的shortcut 包括intent的
      clickFunc[shortcut.shortcut_type]?.(shortcut.shortcut_message, shortcut.query_callback, (res: any) => {
        // 点击埋点
        this.trackingHandler({ next_chat_dialogue_id: res?.dialogue_id });
      });
    }
  };

  // 埋点用 - 点击事件
  trackingHandler = (resParams: any) => {
    const { initStore, tracker } = this.props;

    tracker.click({
      trackingname: this.trackingname,
      data: {
        chat_session_id: initStore.sessionId || '',
        ...this.trackingdata,
        ...resParams,
      },
    });
  };

  render() {
    const {
      shortcut,
      index,
      passedRef,
    } = this.props;
    const trackingdata = JSON.stringify(this.trackingdata);

    const liveAgentShortcutUIOptimisationEnabled = shortcut.is_live_agent && isLiveAgentScUIOptimisation();

    return <div
      data-trackingname={this.trackingname}
      data-trackingindex={index}
      data-trackingdata={trackingdata}
      data-trackingoptype={shortcut.is_live_agent ? TRACKING_OP_TYPE.API_BATCH_REPORT : TRACKING_OP_TYPE.DEFAULT}
      ref={passedRef}
      className={clsx('shortcut', 'chatbot-shortcut', {
        'shortcut-order': shortcut.shortcut_type === ShortcutType.Order,
        'shortcut_new_ui': isShortCutNewUI(),
        'live-agent-sc-optimisation': liveAgentShortcutUIOptimisationEnabled,
      })}
      onClick={this.handleShortcutClick(shortcut)}
    >
      {liveAgentShortcutUIOptimisationEnabled && <ReactSVG src={LiveAgentScIcon} style={{ width: 16, height: 16, marginRight: 4 }} />}
      <span>{shortcut.shortcut_message}</span>
    </div>;
  }
}
